import React from 'react';
import { connectURL } from 'constants/defaultValues';

const globalHRTeams = [
  {
    from: 'We keep losing candidates and I can\u2019t tell if it\u2019s the money.',
    to: 'Pay levels tested against what the market is actually paying to hire.',
  },
  {
    from: 'People are leaving and I think we\u2019re underpaying, but I can\u2019t prove it.',
    to: 'The evidence to see where pay is driving attrition risk.',
  },
  {
    from: 'Our survey data is a year old before we even use it.',
    to: 'Your survey data, read against live hiring activity \u2014 what it actually takes to fill the role now.',
  },
  {
    from: 'I need pay bands built and nobody to build them.',
    to: 'Defensible ranges and job architecture, built with you.',
  },
  {
    from: 'Our incentive plans don\u2019t line up with what the business is trying to do.',
    to: 'Aligned short and long-term incentive goals.',
  },
  {
    from: 'We\u2019ve never actually had a compensation philosophy \u2014 we just pay at the middle.',
    to: 'A philosophy you chose deliberately, with the trade-offs modeled before you commit.',
  },
];

function Rewards() {
  return (
    <div className="section background">
      <div className="container" id="rewards">
        <div className="row">
          <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
            <h2>
              Compensation Design,
              <br />
              Made Simple
            </h2>
            <p>
              Employee pay programs can make or break the success of your
              organization. At WellPay, we make it easier than ever to elevate
              your compensation and total rewards programs with data-driven
              insights. Together, we&apos;re making the world a better place to be
              well paid, one innovative rewards strategy at a time.
            </p>
          </div>
        </div>

        <div className="row flex-column pt-5 px-3">
          <h2 className="text-center w-100">The Wellpay Way:</h2>
          <div className="diff-table">
            <div className="diff-head-row">
              <div className="diff-col">From</div>
              <div className="diff-col">To</div>
            </div>
            <div className="diff-body">
              {globalHRTeams.map((item, index) => (
                <div key={index} className="diff-row">
                  <p className="diff-col">{item.from}</p>
                  <p className="diff-col">{item.to}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex py-5 justify-content-center">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              className="btn btn-light btn-xl"
              href={connectURL}
              target="_blank"
            >
              Talk to us <i className="simple-icon-arrow-right" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rewards;
